import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daho6t3p14a1h3mr6pm0";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);

    const guard = ((formData.get("website_alt") as string) || "").trim();
    if (guard) {
      setStatus("success");
      setFormError("");
      formEl.reset();
      return;
    }
    formData.delete("website_alt");

    setStatus("loading");
    setFormError("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        formEl.reset();
      } else {
        setStatus("error");
        setFormError(
          serverMsg && typeof serverMsg === "string"
            ? serverMsg
            : "提交没有成功，请稍后再试一次。",
        );
      }
    } catch {
      setStatus("error");
      setFormError("网络连接出现问题，请检查网络后重试。");
    }
  };

  return (
    <form
      id="daho6t3p14a1h3mr6pm0"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex w-full flex-col gap-3 sm:flex-row">
        <label className="sr-only" htmlFor="newsletter-email">
          你的邮箱
        </label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="填写你的邮箱，第一时间收到新解读"
          className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        />
        <input
          type="text"
          name="website_alt"
          className="field-guard"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "loading" ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>提交中
            </>
          ) : (
            <>
              <i className="ri-mail-send-line"></i>免费订阅
            </>
          )}
        </button>
      </div>
      {status === "success" && (
        <p className="mt-3 flex items-center gap-1 text-sm text-secondary-600">
          <i className="ri-checkbox-circle-line"></i>订阅成功，感谢关注。
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 flex items-center gap-1 text-sm text-primary-600">
          <i className="ri-error-warning-line"></i>
          {formError}
        </p>
      )}
    </form>
  );
}